import "./home.scss";
import banner from "../../banner.png";
import { Card } from "@sainsburys-tech/luna-card";
import { Heading3 } from "@sainsburys-tech/luna-typography";
import { GridItem, GridWrapper } from "@sainsburys-tech/luna-grid";
import { StandardTile } from "./StandardTile";
import { ChartTile } from "./ChartTile";
import { IRequestParams } from "../../Interfaces/IRequestParams";
import { endpoints } from "../../ApiEndPoints/apiEndPoints";
import { useEffect, useReducer, useState } from "react";
import { initialState, reducer } from "../../Redux/Reducers/paginationReducer";
import { useGetApi } from "../../Redux/Hooks/useGetApi";
import { errorToast } from "../../Service-Utils/toastMessage";
import { useSelector } from "react-redux";
import { userType } from "../../Types/user";
import * as Constants from "../../Constants/index";
import { dashboardFillter } from "../../helpers/dashboardFillterFormatter";
import {
  initialValueOfSearchFamilyGoupForDashboard,
  initialValueOfSearchProductForDailyUpdatesDashboard,
  initialValueOfSearchProductForMissingAttributesDashboard,
} from "../../Models/DashboardModel";
import * as CONSTANT from "../../Constants/index";
import { LOCAL_STORAGE_CONSTANTS } from "../../Constants/constants";
import { consolelog } from "../../helpers/consolelog";
import { setBeforeRefreshObj } from "../Layout/Navbar/navbar";
import store from "../../Store/store";
import { storeFilter } from "../../Redux/Actions/filterActions";

const Home = () => {
  const [{ skip, queryPageSize }] = useReducer(reducer, initialState);

  const [isError, setIsError] = useState(false);
  const [userDetails, setUserDetails] = useState<userType>();
  const user = useSelector((state: any) => state.auth.user);
  useEffect(() => {
    if (user !== null) {
      const userData: userType = {
        name: `${user.profile.firstName} ${user.profile.lastName}`,
        email: user.profile.email,
      };
      setUserDetails(userData);
    }
  }, [user]);

  useEffect(() => {
    setBeforeRefreshObj(
      {
        data: "",
        isDirectQuery: true,
      },
      "/Home",
      "",
      ""
    );
    store.dispatch(storeFilter(null));
  }, []);

  const errorMsg = (msg?: any) => {
    if (!allFamilyGroupIsLoading) {
      consolelog("Error:", msg);
      return <div style={{ color: "red" }}>{msg}</div>;
    }
  };

  //Get All Family Group
  const allFamilyGroupParams: IRequestParams = {
    service: endpoints.getFamilyGroupAdminView(),
    skip: skip,
    take: queryPageSize,
    isEnabled: true,
    filter: "filter",
    key: ``,
    onError(error: any) {
      consolelog(`Error ${error}`);
    },
    onSuccess(result: any) {
      if (result.isAxiosError) {
        let msg = `${result.response.status} ${result.message} ${result.statusText}`;
        setIsError(true);
        errorToast(result.message);
        consolelog(msg);
      } else if (result.status !== 200) {
        errorMsg(result.message);
      } else {
        setAllFamilyGroupCount(result.data["@odata.count"]);
      }
    },
  };

  //Get All Missing Family Group
  let familyGroupFilteredObject = {
    FamilyGroup: null,
  };
  const missingFamilyGroupParams: IRequestParams = {
    service: endpoints.getFamilyGroupAdminView(),
    skip: skip,
    take: queryPageSize,
    isEnabled: true,
    filter: dashboardFillter(
      familyGroupFilteredObject,
      initialValueOfSearchFamilyGoupForDashboard,
      CONSTANT.DashBoardQueryType.FamilyGroupNotAssinged
    ),
    isPaginationRequired: true,
    key: ``,
    onError(error: any) {
      consolelog(`Error ${error}`);
    },
    onSuccess(result: any) {
      if (result.isAxiosError) {
        let msg = `${result.response.status} ${result.message} ${result.statusText}`;
        setIsError(true);
        errorToast(result.message);
        consolelog(msg);
      } else if (result.status !== 200) {
        errorMsg(result.message);
      } else {
        setMissingFamilyGroupCount(result.data["@odata.count"]);
      }
    },
  };

  //Get All Missing Family Group
  let productDailyUpdateObject = {
    UpdatedDate: null,
  };
  const productDailyUpdateParams: IRequestParams = {
    service: endpoints.getProductData(),
    skip: skip,
    take: queryPageSize,
    isEnabled: true,
    isPaginationRequired: true,
    filter: dashboardFillter(
      productDailyUpdateObject,
      initialValueOfSearchProductForDailyUpdatesDashboard,
      CONSTANT.DashBoardQueryType.ProductUpdatedToday
    ),
    key: ``,
    onError(error: any) {
      consolelog(`Error ${error}`);
    },
    onSuccess(result: any) {
      if (result.isAxiosError) {
        let msg = `${result.response.status} ${result.message} ${result.statusText}`;
        setIsError(true);
        errorToast(result.message);
        consolelog(msg);
      } else if (result.status !== 200) {
        errorMsg(result.message);
      } else {
        setProductDailyUpdateCount(result.data["@odata.count"]);
      }
    },
  };

  //Get All Missing Product Attributes
  let productFilteredObject = {
    NewLine: null,
  };
  const productMissingAttributesParams: IRequestParams = {
    service: endpoints.getProductData(),
    skip: skip,
    take: queryPageSize,
    isEnabled: true,
    isPaginationRequired: true,
    filter: dashboardFillter(
      productFilteredObject,
      initialValueOfSearchProductForMissingAttributesDashboard,
      CONSTANT.DashBoardQueryType.NewLineTrue
    ),
    key: ``,
    onError(error: any) {
      consolelog(`Error ${error}`);
    },
    onSuccess(result: any) {
      if (result.isAxiosError) {
        let msg = `${result.response.status} ${result.message} ${result.statusText}`;
        setIsError(true);
        errorToast(result.message);
        consolelog(msg);
      } else if (result.status !== 200) {
        errorMsg(result.message);
      } else {
        setProductMissingAttributesCount(result.data["@odata.count"]);
      }
    },
  };

  const [allFamilyGroupCount, setAllFamilyGroupCount] = useState<number>(0);
  const [missingFamilyGroupCount, setMissingFamilyGroupCount] =
    useState<number>(0);
  const [productDailyUpdateCount, setProductDailyUpdateCount] =
    useState<number>(0);
  const [productMissingAttributesCount, setProductMissingAttributesCount] =
    useState<number>(0);

  const {
    isLoading: allFamilyGroupIsLoading,
    isRefetching: allFamilyGroupIsFetching,
  } = useGetApi(allFamilyGroupParams);
  const {
    isLoading: missingFamilyGroupIsLoading,
    isRefetching: missingFamilyGroupIsFetching,
  } = useGetApi(missingFamilyGroupParams);
  const {
    isLoading: productDailyUpdateIsLoading,
    isRefetching: productDailyUpdateIsFetching,
  } = useGetApi(productDailyUpdateParams);
  const {
    isLoading: productMissingAttributesIsLoading,
    isRefetching: productMissingAttributesIsFetching,
  } = useGetApi(productMissingAttributesParams);

  const chartData = [
    {
      name: "M",
      updates: 30,
    },
    {
      name: "T",
      updates: 10,
    },
    {
      name: "W",
      updates: 15,
    },
    {
      name: "T",
      updates: 16,
    },
    {
      name: "F",
      updates: 23,
    },
    {
      name: "S",
      updates: 30,
    },
    {
      name: "S",
      updates: 26,
    },
  ];

  const getDates = () => {
    let curr = new Date();
    let week = [];

    for (let i = 1; i <= 7; i++) {
      let first = curr.getDate() - curr.getDay() + i;
      let month = new Date(curr.setDate(first)).toLocaleString("default", {
        month: "short",
      });
      let day = new Date(curr.setDate(first)).toISOString().slice(8, 10);

      week.push(`${day} ${month}`);
    }
    return `${week[0]} - ${week[6]}`;
  };
  return (
    <div
      className="containerPanelFullHeight"
      data-test="sainsburys-logo"
      style={{ textAlign: "center" }}
    >
      <div className="home__image-banner">
        <img src={banner} alt="Banner" />
      </div>

      <div className="home__dashboard-container">
        <Card className="home__card-main page-layout__card-desktop">
          <div className="home__card-wrapper">
            <Heading3 className="ln-u-color-orange">
              Welcome back, {userDetails?.name}
            </Heading3>

            {/* <Heading4 className="ln-u-color-black">Let’s get started</Heading4> */}
            <p className="home__card-text ln-font-family-base ln-u-color-black">
              Logistics Data Management covers all areas, not just Product, but
              anything that may be considered Logistics-only or Logistics owned.
              LDM will include methods to capture data where needed, such as via
              an interface to Cubiscan for weights and dimensions (weights and
              dims) but also other information that Logistics could need It will
              include the necessary interfaces and forms to ensure that the data
              is up to date and can be easily updated when needed.{" "}
            </p>
          </div>
        </Card>

        <div className="home__grid-wrapper">
          <GridWrapper
            className="home__grid-container"
            matrix
            equalHeight={true}
          >
            <GridItem size={{ xs: "1/3" }}>
              <Card>
                <StandardTile
                  title="Family Group Summary"
                  subtitle=""
                  value={allFamilyGroupCount}
                  bodyText="Family Groups"
                  queryName={Constants.DashboardFilterContants.FamilyGroupAll}
                  buttonText={"View Family Groups"}
                  isLoading={
                    allFamilyGroupIsLoading || allFamilyGroupIsFetching
                  }
                />
              </Card>
            </GridItem>
            <GridItem size={{ xs: "1/3" }}>
              <Card>
                <ChartTile
                  title="Family Group Summary"
                  subtitle="Weekly Updates"
                  dateRange={getDates()}
                  chartData={chartData}
                />
              </Card>
            </GridItem>
            <GridItem size={{ xs: "1/3" }}>
              <Card>
                <StandardTile
                  title="Family Group Summary"
                  subtitle=""
                  value={missingFamilyGroupCount}
                  bodyText="Missing Family Groups"
                  queryName={
                    Constants.DashboardFilterContants.FamilyGroupFiltered
                  }
                  buttonText={"View Family Groups"}
                  isLoading={
                    missingFamilyGroupIsLoading || missingFamilyGroupIsFetching
                  }
                />
              </Card>
            </GridItem>
            <GridItem size={{ xs: "1/3" }}>
              <Card>
                <StandardTile
                  title="Product Summary"
                  subtitle="Daily Updates"
                  value={productDailyUpdateCount}
                  bodyText="Items measured recently"
                  queryName={
                    Constants.DashboardFilterContants.ProductDailyUpdate
                  }
                  buttonText={"View Products"}
                  isLoading={
                    productDailyUpdateIsLoading || productDailyUpdateIsFetching
                  }
                />
              </Card>
            </GridItem>
            <GridItem size={{ xs: "1/3" }}>
              <Card>
                <ChartTile
                  title="Product Summary"
                  subtitle="Weekly Updates"
                  dateRange={getDates()}
                  chartData={chartData}
                />
              </Card>
            </GridItem>
            <GridItem size={{ xs: "1/3" }}>
              <Card>
                <StandardTile
                  title="Product Summary"
                  subtitle=""
                  value={productMissingAttributesCount}
                  bodyText="Items with missing Attributes"
                  queryName={Constants.DashboardFilterContants.ProductFiltered}
                  buttonText={"View Products"}
                  isLoading={
                    productMissingAttributesIsLoading ||
                    productMissingAttributesIsFetching
                  }
                />
              </Card>
            </GridItem>
          </GridWrapper>
        </div>
      </div>
    </div>
  );
};

export default Home;
